import React from "react";
import { Grid, Box, UnstyledButton } from "@mantine/core";

const WrappingBox = ({ children, ...rest }) => {
  return (
    <Box className="segment-box" px="xs" {...rest}>
      {children}
    </Box>
  );
};

const ClickableBox = ({ children, onClick }) => {
  return (
    <WrappingBox component={UnstyledButton} onClick={onClick}>
      {children}
    </WrappingBox>
  );
};

export const SegmentWidget = ({ onClick, children, span, ...rest }) => {
  const Wrapper = onClick ? ClickableBox : WrappingBox;

  return (
    <Grid.Col className="segment-col" span={span}>
      <Wrapper onClick={onClick} {...rest}>
        {children}
      </Wrapper>
    </Grid.Col>
  );
};
